query MyUser {
  user: myUser {
    id
    insertedAt
    updatedAt
    name
    first_name
    last_name
    email
    authProfile {
      id
      insertedAt
      updatedAt
      lockedAt
      passwordCreatedAt
      passwordExpiredAt
      mfaTotpEnabled
      mfaEmailEnabled
      mfaSmsEnabled
      mfaSmsPhoneNumber
    }
    account {
      id
      name
      defaultAutoResponse {
        id
      }

      supportPlan {
        id
        name
      }

      servicePlan {
        id
        name
        # maxSubAccounts
      }

      parentAccount {
        id
        name
      }
    }
    role {
      id
      name
      resources {
        resourceId
        scope
        actions {
          name
          value
        }
      }
    }
  }
}
